module.exports = __webpack_public_path__ + "media/Audio22.0f5b84a7.wav";